import React from 'react';

export const DashboardIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.87868 3.87868C2 4.75736 2 6.17157 2 9V15C2 17.8284 2 19.2426 2.87868 20.1213C3.75736 21 5.17157 21 8 21H16C18.8284 21 20.2426 21 21.1213 20.1213C22 19.2426 22 17.8284 22 15V9C22 6.17157 22 4.75736 21.1213 3.87868C20.2426 3 18.8284 3 16 3H8C5.17157 3 3.75736 3 2.87868 3.87868ZM16 8C16.5523 8 17 8.44772 17 9V17C17 17.5523 16.5523 18 16 18C15.4477 18 15 17.5523 15 17V9C15 8.44772 15.4477 8 16 8ZM9 11C9 10.4477 8.55228 10 8 10C7.44772 10 7 10.4477 7 11V17C7 17.5523 7.44772 18 8 18C8.55229 18 9 17.5523 9 17V11ZM13 13C13 12.4477 12.5523 12 12 12C11.4477 12 11 12.4477 11 13V17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17V13Z"
        fill="white"
      />
    </svg>
  );
};

export const GetStartedIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_13_145)">
        <path
          d="M0.461496 11.325C0.00852777 10.6586 -0.0820191 9.81008 0.220129 9.06309C0.895403 7.68555 2.02661 6.58422 3.42173 5.9461C4.43181 5.4438 5.52591 5.13227 6.64903 5.02708C6.15966 5.62926 5.66974 6.27176 5.17927 6.95469C4.18107 8.46626 3.32661 10.068 2.62712 11.7389L2.32603 12.414C1.57181 12.3516 0.88634 11.9513 0.461496 11.325ZM1.60861 14.8285C0.887981 15.8235 0.370754 16.9509 0.0866137 18.1462C-0.0905347 18.9229 0.395442 19.6961 1.17212 19.8732C1.38349 19.9215 1.60298 19.9214 1.81435 19.8731C3.00779 19.5885 4.13345 19.0716 5.12712 18.3519C6.10009 17.3794 6.10048 15.8023 5.12794 14.8293C4.15544 13.8563 2.57829 13.8559 1.60532 14.8285H1.60861ZM8.19181 17.3002L7.51169 17.6021V17.846C7.51333 18.4302 7.74728 18.9897 8.16196 19.4012C8.55642 19.7848 9.08482 19.9996 9.63505 20C11.59 19.9718 13.1751 18.1919 14.007 16.5347C14.5167 15.5091 14.8292 14.3969 14.9285 13.2559C14.3202 13.7536 13.668 14.2513 12.9718 14.7489C11.4609 15.7474 9.85939 16.6016 8.18849 17.3002L8.19181 17.3002ZM19.9532 2.45419C19.8429 6.06469 17.2434 9.64536 12.0056 13.4027C10.5802 14.3267 9.07646 15.1238 7.51169 15.7849V15.3179C7.50396 13.7178 6.20876 12.4226 4.60868 12.4149H4.14173C4.80431 10.8501 5.60278 9.34637 6.52802 7.92102C10.2762 2.69555 13.851 0.0927795 17.4558 -0.0249939C19.2523 -0.0249939 19.9532 0.706569 19.9532 2.45419ZM14.9766 7.02352C14.9766 5.87833 14.0482 4.94993 12.903 4.94993C11.7577 4.94993 10.8294 5.87829 10.8294 7.02352C10.8294 8.16872 11.7577 9.09712 12.903 9.09712C14.0482 9.09712 14.9766 8.16872 14.9766 7.02352Z"
          fill="#F2F2F2"
        />
      </g>
    </svg>
  );
};

export const ZenBrainIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_14_449)">
        <path
          d="M9.16667 14.1667V17.455C9.16667 18.595 8.40333 19.62 7.29333 19.88C6.95833 19.9583 6.60917 20 6.25 20C4.23167 20 2.4875 18.7033 1.88917 16.8042C0.715833 16.0367 0 14.7383 0 13.3333C0 12.595 0.195833 11.8858 0.571667 11.25C0.196667 10.6142 0 9.905 0 9.16667C0 7.86 0.626667 6.63333 1.66667 5.85083V5.83333C1.66667 4.2525 2.7725 2.92583 4.25167 2.585C4.5925 1.10667 5.92 0 7.5 0H7.51833C8.42917 0.0025 9.16667 0.7425 9.16667 1.65333V6.66667H7.26917C6.98083 6.17083 6.44917 5.83333 5.83333 5.83333C4.9125 5.83333 4.16667 6.57917 4.16667 7.5C4.16667 8.42083 4.9125 9.16667 5.83333 9.16667C6.44833 9.16667 6.98 8.82917 7.26917 8.33333H9.16667V12.5H7.26917C6.98083 12.0042 6.44917 11.6667 5.83333 11.6667C4.9125 11.6667 4.16667 12.4125 4.16667 13.3333C4.16667 14.2542 4.9125 15 5.83333 15C6.44833 15 6.98 14.6625 7.26917 14.1667H9.16667ZM20 9.16667C20 7.86 19.3733 6.63333 18.3333 5.85083V5.83333C18.3333 4.2525 17.2275 2.92583 15.7483 2.585C15.4075 1.10667 14.08 0 12.5 0H12.4817C11.5708 0.0025 10.8333 0.7425 10.8333 1.65333V10H13.3333V8.93583C12.8375 8.6475 12.5 8.11583 12.5 7.5C12.5 6.57917 13.2458 5.83333 14.1667 5.83333C15.0875 5.83333 15.8333 6.57917 15.8333 7.5C15.8333 8.115 15.4958 8.64667 15 8.93583V11.6667H10.8333V17.455C10.8333 18.595 11.5967 19.62 12.7067 19.88C13.0417 19.9583 13.3908 20 13.75 20C15.7683 20 17.5125 18.7033 18.1108 16.8042C19.2842 16.0367 20 14.7383 20 13.3333C20 12.595 19.8042 11.8858 19.4283 11.25C19.8033 10.6142 20 9.905 20 9.16667Z"
          fill="#F2F2F2"
        />
      </g>
    </svg>
  );
};
export const SubscriptionsIcon = () => {
  let path =
    'M1.16126 9.08419C1.56126 5.28419 4.36126 2.20419 8.00126 1.38419L7.38126 0.864186C7.18126 0.684186 7.16126 0.364186 7.34126 0.164186C7.50126 -0.0158136 7.78126 -0.0558136 8.00126 0.0841864L9.46126 1.24419C9.56126 1.32419 9.62126 1.44419 9.64126 1.58419C9.66126 1.72419 9.62126 1.86419 9.54126 1.96419L8.38126 3.42419C8.28126 3.54419 8.14126 3.62419 7.98126 3.60419C7.70126 3.60419 7.48126 3.38419 7.48126 3.10419C7.48126 2.98419 7.52126 2.86419 7.58126 2.78419L7.86126 2.44419C4.80126 3.30419 2.52126 5.94419 2.16126 9.18419C2.14126 9.44419 1.92126 9.62419 1.66126 9.62419H1.62126C1.34126 9.60419 1.14126 9.36419 1.16126 9.08419ZM9.14126 17.7842C5.88126 17.4442 3.24126 15.1242 2.40126 12.0442L2.80126 12.3642C3.02126 12.5442 3.34126 12.5042 3.50126 12.2842C3.68126 12.0642 3.64126 11.7442 3.42126 11.5842L1.96126 10.4042C1.86126 10.3242 1.72126 10.2842 1.60126 10.3042C1.46126 10.3242 1.34126 10.3842 1.26126 10.4842L0.101263 11.9442C0.0212633 12.0242 0.00126334 12.1442 0.00126334 12.2642C-0.0187367 12.5442 0.201263 12.7642 0.481263 12.7642C0.641263 12.7642 0.781263 12.7042 0.881263 12.5842L1.36126 11.9842C2.20126 15.6242 5.26126 18.3842 9.06126 18.7842H9.10126C9.38126 18.8042 9.62126 18.5842 9.62126 18.3042C9.64126 18.0442 9.42126 17.8042 9.14126 17.7842ZM18.3013 10.3642C18.0213 10.3442 17.7813 10.5442 17.7413 10.8042C17.4013 14.0442 15.1013 16.6842 12.0413 17.5442L12.3813 17.1242C12.5613 16.9042 12.5213 16.5842 12.3013 16.4242C12.0813 16.2442 11.7613 16.2842 11.6013 16.5042L10.5013 17.8842C10.3613 17.9842 10.2813 18.1442 10.3013 18.3042C10.3013';
  let path2 =
    '18.5042 10.4413 18.6642 10.6013 18.7442L11.9613 19.8442C12.0413 19.9042 12.1613 19.9442 12.2813 19.9442C12.4413 19.9442 12.5813 19.8842 12.6613 19.7642C12.8413 19.5442 12.8013 19.2242 12.5813 19.0642L12.0013 18.6042C15.6013 17.7442 18.3413 14.6842 18.7413 10.9242C18.7813 10.6242 18.5813 10.3842 18.3013 10.3642ZM19.8013 7.46419C19.5813 7.28419 19.2613 7.32419 19.1013 7.54419L18.6013 8.16419C17.8013 4.46419 14.7213 1.62419 10.8813 1.20419C10.6013 1.16419 10.3413 1.36419 10.3213 1.64419C10.3013 1.92419 10.5013 2.16419 10.7613 2.20419C14.0613 2.56419 16.7413 4.92419 17.5413 8.06419L17.1613 7.74419C16.9413 7.56419 16.6213 7.60419 16.4613 7.82419C16.3013 8.04419 16.3213 8.36419 16.5413 8.52419L18.0013 9.68419C18.0813 9.74419 18.2013 9.78419 18.3213 9.78419C18.4813 9.78419 18.6213 9.72419 18.7213 9.60419L19.8813 8.14419C20.0413 7.94419 20.0213 7.62419 19.8013 7.46419ZM9.98126 15.1842C7.08126 15.1842 4.72126 12.8242 4.72126 9.92419C4.72126 7.02419 7.08126 4.66419 9.98126 4.66419C12.8813 4.66419 15.2413 7.02419 15.2413 9.92419C15.2413 12.8442 12.8813 15.1842 9.98126 15.1842ZM11.6413 11.0842C11.6413 10.1642 10.9013 9.42419 9.98126 9.42419C9.62126 9.42419 9.32126 9.12419 9.32126 8.76419C9.32126 8.40419 9.62126 8.10419 9.98126 8.10419C10.3413 8.10419 10.6413 8.40419 10.6413 8.76419C10.6413 9.04419 10.8613 9.26419 11.1413 9.26419C11.4213 9.26419 11.6413 9.04419 11.6413 8.76419C11.6413 8.02419 11.1813 7.38419 10.4813 7.16419V7.08419C10.4813 6.80419 10.2613 6.58419 9.98126 6.58419C9.70126 6.58419 9.48126 6.80419 9.48126 7.08419V7.16419C8.78126 7.38419 8.30126 8.04419 8.30126 8.78419C8.32126 9.70419 9.06126 10.4442 9.98126 10.4242C10.3213 10.4442 10.5813 10.7042 10.6013 11.0442C10.6213 11.4042 10.3413 11.7242 9.98126 11.7442C9.62126 11.7442 9.32126 11.4442 9.32126 11.0842C9.32126 10.8042 9.10126 10.5842 8.82126 10.5842C8.54126 10.5842 8.32126 10.8042 8.32126 11.0842C8.32126 11.8042 8.80126 12.4442 9.48126 12.6642V12.7642C9.48126 13.0442 9.70126 13.2642 9.98126 13.2642C10.2613 13.2642 10.4813 13.0442 10.4813 12.7642V12.6642C11.1813 12.4442 11.6413 11.8042 11.6413 11.0842Z';
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path d={`${path}${path2}`} fill="#F2F2F2"></path>
    </svg>
  );
};

export const ReplenishIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.57809 0.105088L11.1062 1.5647L2.90977 6.29692V9.80353C2.90977 9.94364 2.97922 10.064 3.10059 10.134L5.00051 11.2309C5.06117 11.266 5.13062 11.266 5.19133 11.2309C5.25199 11.1959 5.28672 11.1358 5.28672 11.0657V7.66927L13.4832 2.93704L16.0113 4.39665C16.254 4.53677 16.393 4.77739 16.393 5.05763V9.44395C15.7066 9.21243 14.9804 9.08755 14.255 9.04329V8.74923C14.255 8.42884 14.0721 8.14153 13.7818 8.00599C13.4916 7.87048 13.1538 7.91462 12.9082 8.12017L9.99805 10.5558C9.75664 10.7579 9.62473 11.0525 9.6348 11.3671C9.64488 11.683 9.7943 11.9665 10.0491 12.1535L12.9495 14.2814C13.1999 14.4651 13.5283 14.4921 13.8054 14.3517C14.0828 14.2112 14.255 13.9309 14.255 13.62V13.2953C14.8586 13.3673 15.4562 13.5529 15.9468 13.9081C16.042 13.977 16.1323 14.0521 16.2162 14.1327C16.1601 14.1986 16.0914 14.2556 16.0114 14.3018L8.57809 18.5934C8.33539 18.7335 8.05754 18.7335 7.81484 18.5934L0.381641 14.3018C0.138906 14.1617 0 13.9211 0 13.6408V5.05767C0 4.77739 0.138906 4.53677 0.381641 4.39669L7.81488 0.105088C8.05758 -0.0350293 8.33539 -0.0350293 8.57809 0.105088ZM13.63 12.6341C17.7116 12.6341 18.8683 16.5325 15.5157 18.2848C15.4973 18.2943 15.4895 18.3163 15.4979 18.3352C15.5058 18.3528 15.5245 18.3622 15.5432 18.3575C21.1133 16.9874 20.7239 9.6495 13.63 9.6495V8.74923C13.63 8.67157 13.5877 8.60513 13.5173 8.57228C13.447 8.53942 13.3689 8.54962 13.3093 8.59946L10.3992 11.0352C10.304 11.1148 10.2555 11.2232 10.2595 11.3472C10.2634 11.4712 10.3188 11.5763 10.4188 11.6497L13.3191 13.7775C13.38 13.8222 13.4556 13.8284 13.5229 13.7943C13.5902 13.7602 13.63 13.6955 13.63 13.62V12.6341Z"
        fill="#F2F2F2"
      />
    </svg>
  );
};

export const SmartyMessageIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
    >
      <path
        d="M18.5955 4.18293H18.0478V10.2036C18.0478 11.141 17.502 11.9887 16.4078 11.9887H5.68762V12.2749C5.68762 13.1037 6.63025 13.9403 7.59824 13.9403H15.7943L18.9299 15.7839L18.4752 13.9403H18.5955C19.5628 13.9403 19.9994 13.1056 19.9994 12.2749V5.61215C19.9994 4.78337 19.5628 4.18293 18.5955 4.18293Z"
        fill="#F2F2F2"
      />
      <path
        d="M14.8074 0H2.35623C1.26073 0 0 0.973198 0 1.91127V9.45746C0 10.3214 1.06818 10.9452 2.09277 11.0415L1.42597 13.5727L5.69867 11.0591H14.8074C15.9029 11.0591 16.9139 10.3949 16.9139 9.45746V3.3522V1.91127C16.9139 0.973198 15.9023 0 14.8074 0ZM4.25579 6.37002C3.63453 6.37002 3.13102 5.86651 3.13102 5.24525C3.13102 4.62399 3.63453 4.12048 4.25579 4.12048C4.8764 4.12048 5.38056 4.62399 5.38056 5.24525C5.38056 5.86651 4.8764 6.37002 4.25579 6.37002ZM8.45693 6.37002C7.83568 6.37002 7.33216 5.86651 7.33216 5.24525C7.33216 4.62399 7.83568 4.12048 8.45693 4.12048C9.07819 4.12048 9.58171 4.62399 9.58171 5.24525C9.58171 5.86651 9.07819 6.37002 8.45693 6.37002ZM12.6587 6.37002C12.0375 6.37002 11.5333 5.86651 11.5333 5.24525C11.5333 4.62399 12.0375 4.12048 12.6587 4.12048C13.2787 4.12048 13.7835 4.62399 13.7835 5.24525C13.7835 5.86651 13.2787 6.37002 12.6587 6.37002Z"
        fill="#F2F2F2"
      />
    </svg>
  );
};

export const MoreIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
    >
      <g clipPath="url(#clip0_13_402)">
        <path
          d="M11.1791 17.5122L19 9.69451L17.8774 8.5751L10.0597 16.3928C9.91125 16.5412 9.70992 16.6246 9.5 16.6246C9.29008 16.6246 9.08875 16.5412 8.94029 16.3928L1.10833 8.5648L-0.0110836 9.68422L7.81692 17.5122C8.26229 17.9575 8.86628 18.2076 9.49604 18.2076C10.1258 18.2076 10.7298 17.9575 11.1752 17.5122H11.1791Z"
          fill="#F2F2F2"
        />
        <path
          d="M10.0597 10.715L18.985 1.79052L17.8656 0.670314L9.50003 9.03586L1.12578 0.661606L0.00556946 1.78102L8.94032 10.715C9.08878 10.8634 9.29011 10.9468 9.50003 10.9468C9.70995 10.9468 9.91128 10.8634 10.0597 10.715Z"
          fill="#F2F2F2"
        />
      </g>
    </svg>
  );
};

export const SubscriptionContractsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M18.4375 5.9375H16.25C16.0775 5.9375 15.9375 5.7975 15.9375 5.625V3.4375L18.4375 5.9375Z"
        fill="#F2F2F2"
      />
      <path
        d="M15.625 6.875C15.28 6.875 15 6.595 15 6.25V3.125H8.4375C8.265 3.125 8.125 3.265 8.125 3.4375V16.5625C8.125 16.735 8.265 16.875 8.4375 16.875H18.4375C18.61 16.875 18.75 16.735 18.75 16.5625V6.875H15.625ZM10.1875 5.625H12.9375C13.0413 5.625 13.125 5.70875 13.125 5.8125V6.6875C13.125 6.79125 13.0413 6.875 12.9375 6.875H10.1875C10.0837 6.875 10 6.79125 10 6.6875V5.8125C10 5.70875 10.0837 5.625 10.1875 5.625ZM16.6875 14.375H13.9375C13.8337 14.375 13.75 14.2913 13.75 14.1875V13.3125C13.75 13.2087 13.8337 13.125 13.9375 13.125H16.6875C16.7913 13.125 16.875 13.2087 16.875 13.3125V14.1875C16.875 14.2913 16.7913 14.375 16.6875 14.375ZM16.6875 11.875H10.1875C10.0837 11.875 10 11.7913 10 11.6875V10.8125C10 10.7087 10.0837 10.625 10.1875 10.625H16.6875C16.7913 10.625 16.875 10.7087 16.875 10.8125V11.6875C16.875 11.7913 16.7913 11.875 16.6875 11.875ZM16.6875 9.375H10.1875C10.0837 9.375 10 9.29125 10 9.1875V8.3125C10 8.20875 10.0837 8.125 10.1875 8.125H16.6875C16.7913 8.125 16.875 8.20875 16.875 8.3125V9.1875C16.875 9.29125 16.7913 9.375 16.6875 9.375Z"
        fill="#F2F2F2"
      />
      <path
        d="M2.8125 11.5625C1.94937 11.5625 1.25 10.8631 1.25 10C1.25 9.13687 1.94937 8.4375 2.8125 8.4375C3.45312 8.4375 4.00187 8.82375 4.24312 9.375H7.1875V10.625H4.24312C4.00187 11.1762 3.45312 11.5625 2.8125 11.5625Z"
        fill="#F2F2F2"
      />
      <path
        d="M3.4375 17.8125C2.57437 17.8125 1.875 17.1131 1.875 16.25C1.875 15.265 2.7875 14.4956 3.79438 14.7325L4.8125 13.375C4.93062 13.2175 5.11562 13.125 5.3125 13.125H7.1875V14.375H5.625L4.79187 15.485C5.39437 16.5487 4.61125 17.8125 3.4375 17.8125Z"
        fill="#F2F2F2"
      />
      <path
        d="M3.4375 2.1875C4.61625 2.1875 5.39188 3.455 4.7925 4.515L5.625 5.625H7.1875V6.875H5.3125C5.11562 6.875 4.93062 6.7825 4.8125 6.625L3.795 5.2675C2.78688 5.50438 1.875 4.73438 1.875 3.75C1.875 2.88687 2.57437 2.1875 3.4375 2.1875Z"
        fill="#F2F2F2"
      />
    </svg>
  );
};

export const CustomersIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
    >
      <path
        d="M10 6.79688C11.8769 6.79688 13.3984 5.27534 13.3984 3.39844C13.3984 1.52153 11.8769 0 10 0C8.12309 0 6.60156 1.52153 6.60156 3.39844C6.60156 5.27534 8.12309 6.79688 10 6.79688Z"
        fill="#F2F2F2"
      />
      <path
        d="M16.875 6.79684C18.0615 6.79684 19.0234 5.83495 19.0234 4.6484C19.0234 3.46185 18.0615 2.49996 16.875 2.49996C15.6885 2.49996 14.7266 3.46185 14.7266 4.6484C14.7266 5.83495 15.6885 6.79684 16.875 6.79684Z"
        fill="#F2F2F2"
      />
      <path
        d="M3.125 6.79684C4.31155 6.79684 5.27344 5.83495 5.27344 4.6484C5.27344 3.46185 4.31155 2.49996 3.125 2.49996C1.93845 2.49996 0.976562 3.46185 0.976562 4.6484C0.976562 5.83495 1.93845 6.79684 3.125 6.79684Z"
        fill="#F2F2F2"
      />
      <path
        d="M5.2418 8.72617C4.39609 8.03328 3.6302 8.125 2.65234 8.125C1.18984 8.125 0 9.30781 0 10.7613V15.0273C0 15.6586 0.515234 16.1719 1.14883 16.1719C3.88422 16.1719 3.55469 16.2214 3.55469 16.0539C3.55469 13.031 3.19664 10.8142 5.2418 8.72617Z"
        fill="#F2F2F2"
      />
      <path
        d="M10.9301 8.14058C9.2221 7.99812 7.73753 8.14222 6.45702 9.19918C4.31417 10.9156 4.72655 13.2266 4.72655 16.0539C4.72655 16.8019 5.33515 17.4218 6.09452 17.4218C14.3399 17.4218 14.6681 17.6878 15.157 16.605C15.3174 16.2389 15.2734 16.3552 15.2734 12.8523C15.2734 10.07 12.8643 8.14058 10.9301 8.14058Z"
        fill="#F2F2F2"
      />
      <path
        d="M17.3476 8.12496C16.3644 8.12496 15.6027 8.03418 14.7582 8.72613C16.7881 10.7986 16.4453 12.8642 16.4453 16.0539C16.4453 16.2224 16.1717 16.1718 18.8101 16.1718C19.4664 16.1718 20 15.6402 20 14.9867V10.7613C20 9.30777 18.8101 8.12496 17.3476 8.12496Z"
        fill="#F2F2F2"
      />
    </svg>
  );
};

export const AnalyticsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_14_488)">
        <path
          d="M0.555623 12.7952H2.77771C3.08451 12.7952 3.33333 13.0438 3.33333 13.3506V18.9062C3.33333 19.2131 3.08451 19.4619 2.77771 19.4619H0.555623C0.24882 19.4619 0 19.2131 0 18.9062V13.3506C0 13.0438 0.24882 12.7952 0.555623 12.7952Z"
          fill="#F2F2F2"
        />
        <path
          d="M6.11102 8.35062H8.33331C8.64012 8.35062 8.88894 8.59944 8.88894 8.90625V18.9062C8.88894 19.2131 8.64012 19.4619 8.33331 19.4619H6.11102C5.80422 19.4619 5.5556 19.2131 5.5556 18.9062V8.90625C5.5556 8.59944 5.80422 8.35062 6.11102 8.35062Z"
          fill="#F2F2F2"
        />
        <path
          d="M11.6666 10.5729H13.8889C14.1957 10.5729 14.4444 10.8217 14.4444 11.1285V18.9062C14.4444 19.2131 14.1957 19.4619 13.8889 19.4619H11.6666C11.3598 19.4619 11.111 19.2131 11.111 18.9062V11.1285C11.111 10.8217 11.3598 10.5729 11.6666 10.5729Z"
          fill="#F2F2F2"
        />
        <path
          d="M17.2223 7.23959H19.4444C19.7512 7.23959 20 7.48841 20 7.79521V18.9063C20 19.2131 19.7512 19.4619 19.4444 19.4619H17.2223C16.9155 19.4619 16.6667 19.2131 16.6667 18.9063V7.79521C16.6667 7.48841 16.9155 7.23959 17.2223 7.23959Z"
          fill="#F2F2F2"
        />
        <path
          d="M18.3333 0.572914C17.4133 0.573931 16.6677 1.31958 16.6667 2.23958C16.6689 2.42106 16.701 2.60091 16.7619 2.77181L13.9807 4.42505C13.6157 4.03788 13.0865 3.8503 12.5592 3.9209C12.0317 3.99149 11.5706 4.31172 11.3202 4.78129L8.86719 3.56628C8.87919 3.49487 8.88631 3.42285 8.88896 3.35062C8.89018 2.67598 8.4847 2.06726 7.86173 1.80827C7.23877 1.54948 6.5212 1.69169 6.04411 2.16858C5.56681 2.64546 5.42419 3.36283 5.68278 3.986L2.50081 6.36067C2.24854 6.21032 1.96045 6.13017 1.66667 6.12854C0.746256 6.12854 0 6.87459 0 7.7952C0 8.71561 0.746256 9.46187 1.66667 9.46187C2.58708 9.46187 3.33333 8.71561 3.33333 7.7952C3.33191 7.5946 3.29407 7.39624 3.22164 7.20927L6.43534 4.81079C7.06401 5.16133 7.8481 5.05859 8.36507 4.5577L11.1546 5.93933C11.3405 6.76758 12.12 7.3234 12.9637 7.22941C13.8074 7.13541 14.4454 6.42191 14.4444 5.57291C14.4444 5.5306 14.435 5.49072 14.432 5.44922L17.4569 3.65092C17.7191 3.81673 18.0229 3.90523 18.3333 3.90625C19.2537 3.90625 20 3.15999 20 2.23958C20 1.31917 19.2537 0.572914 18.3333 0.572914Z"
          fill="#F2F2F2"
        />
      </g>
    </svg>
  );
};

export const TiazenIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M18.2449 8.30385L10.4446 0.502391C9.98457 0.0434842 9.24038 0.0489139 8.78636 0.501805C8.32976 0.95958 8.32976 1.70286 8.78636 2.16005L16.5878 9.96097C17.0449 10.418 17.7879 10.418 18.2449 9.96097C18.7032 9.50268 18.7032 8.76206 18.2449 8.30385Z"
        fill="#F2F2F2"
      />
      <path
        d="M8.20761 3.23848L8.1489 3.53278C7.73535 5.60145 6.73027 7.56673 5.37085 9.15958L9.61488 13.4036C11.2075 12.0445 13.1457 11.0124 15.2145 10.5983L15.5093 10.5396L8.20761 3.23848Z"
        fill="#F2F2F2"
      />
      <path
        d="M4.59278 10.0387L1.69227 12.9386C1.00692 13.6239 1.00407 14.7366 1.69227 15.4248L3.34938 17.0819C4.03474 17.7673 5.14739 17.7701 5.8356 17.0819L8.73584 14.1817L4.59278 10.0387ZM5.00708 14.5963C4.77821 14.8251 4.40739 14.8251 4.17852 14.5963C3.94966 14.3674 3.94966 13.9966 4.17852 13.7677L5.00708 12.9392C5.23595 12.7103 5.60677 12.7103 5.83564 12.9392C6.06451 13.168 6.06451 13.5389 5.83564 13.7677L5.00708 14.5963Z"
        fill="#F2F2F2"
      />
      <path
        d="M11.1823 17.3937L11.9794 16.5966C12.6676 15.9085 12.6654 14.7959 11.9794 14.111L11.3874 13.5186C11.0602 13.7384 10.7477 13.9772 10.4438 14.2321L11.1509 14.9402C11.3792 15.1673 11.3808 15.537 11.1509 15.7681L10.3406 16.5784L9.14993 15.4247L7.49274 17.0819L10.1512 19.658C10.6049 20.1128 11.3498 20.1154 11.8077 19.6574C12.2649 19.2002 12.2649 18.4569 11.8077 17.9997L11.1823 17.3937Z"
        fill="#F2F2F2"
      />
      <path
        d="M13.5494 0C13.2255 0 12.9634 0.262071 12.9634 0.585939V1.75782C12.9634 2.08168 13.2255 2.34375 13.5494 2.34375C13.8732 2.34375 14.1353 2.08168 14.1353 1.75782V0.585939C14.1353 0.262071 13.8732 0 13.5494 0Z"
        fill="#F2F2F2"
      />
      <path
        d="M18.2369 4.68752H17.0651C16.7412 4.68752 16.4791 4.94959 16.4791 5.27345C16.4791 5.59732 16.7412 5.85939 17.0651 5.85939H18.2369C18.5608 5.85939 18.8229 5.59732 18.8229 5.27345C18.8229 4.94959 18.5608 4.68752 18.2369 4.68752Z"
        fill="#F2F2F2"
      />
      <path
        d="M17.4793 1.34353C17.2504 1.11466 16.8796 1.11466 16.6507 1.34353L15.4788 2.5154C15.25 2.74427 15.25 3.11509 15.4788 3.34396C15.7077 3.57283 16.0785 3.57287 16.3074 3.34396L17.4793 2.17208C17.7081 1.94321 17.7081 1.57239 17.4793 1.34353Z"
        fill="#F2F2F2"
      />
    </svg>
  );
};

export const ZennPortalIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_14_531)">
        <path
          d="M10 0C4.5 0 0 4.5 0 10C0 15.5 4.5 20 10 20C15.5 20 20 15.5 20 10C20 4.5 15.5 0 10 0ZM10 3C11.7 3 13 4.3 13 6C13 7.7 11.7 9 10 9C8.3 9 7 7.7 7 6C7 4.3 8.3 3 10 3ZM10 17.2C7.5 17.2 5.3 15.9 4 14C4 12 8 10.9 10 10.9C12 10.9 16 12 16 14C14.7 15.9 12.5 17.2 10 17.2Z"
          fill="#F2F2F2"
        />
      </g>
    </svg>
  );
};

export const ThemeIcon = () => {
  let path =
    'M19.5959 0.514184C19.5585 0.419505 19.4723 0.352883 19.3712 0.340521C19.2704 0.328206 19.1705 0.372096 19.1114 0.454969C18.7604 0.94707 18.2998 1.1111 17.7663 1.30106C17.3361 1.45431 16.8912 1.61265 16.4104 1.95785C15.7304 2.44601 15.4194 3.11145 15.5745 3.74217L15.5579 3.76342C15.274 3.35151 14.965 2.97052 14.639 2.63032C13.1136 1.03869 10.9822 0.0818084 8.79109 0.0050928C8.69455 0.00171305 8.59645 0 8.4995 0C6.05284 0 3.711 1.09374 2.07451 3.00071C0.446583 4.89781 -0.27497 7.36739 0.0949503 9.77622C0.125877 9.97757 0.164582 10.181 0.210093 10.381C0.811781 13.0293 2.34855 15.044 4.4264 15.9082C4.93859 16.1213 5.45523 16.2292 5.96177 16.2292C7.22029 16.2292 8.31954 15.5561 8.97776 14.3824C9.22795 13.9359 9.38939 13.474 9.45741 13.0097C9.4975 12.7356 9.47009 12.4617 9.44352 12.1964C9.41615 11.9232 9.39032';
  let path2 =
    '11.665 9.43166 11.4051C9.52643 10.8093 9.94261 10.4536 10.545 10.4536C10.7163 10.4536 10.8914 10.4818 11.0663 10.5374C10.8616 10.9129 10.6756 11.2715 10.5132 11.6038C10.1689 12.3081 9.93136 12.8913 9.80705 13.3372C9.73042 13.6121 9.52685 14.3429 10.0233 14.6874C10.1809 14.7968 10.3808 14.8354 10.5888 14.7967C10.7762 14.7619 11.3466 14.6559 12.9675 12.8107C13.4025 12.3156 13.8713 11.7425 14.3612 11.1072C15.6191 10.6836 16.5979 9.62936 16.8568 8.41793C16.9216 8.1151 16.9487 7.79101 16.9372 7.45438C17.4081 6.72658 17.8212 6.04748 18.2368 5.31745C18.2448 5.30338 18.2527 5.28838 18.2604 5.27301C18.8637 5.10777 19.3834 4.63826 19.6884 3.98171C20.1337 3.02348 20.1008 1.79196 19.5959 0.514184ZM12.796 5.05161C12.5778 5.39815 12.2028 5.60506 11.7926 5.60506C11.5699 5.60506 11.3521 5.54204 11.1627 5.42278C10.895 5.25416 10.7089 4.99142 10.6388 4.68294C10.5688 4.37446 10.6229 4.05709 10.7915 3.78934C11.0098 3.4428 11.3849 3.2359 11.795 3.2359C12.0178 3.2359 12.2356 3.29891 12.4249 3.41822C12.6926 3.58675 12.8787 3.84949 12.9488 4.15801C13.0188 4.46654 12.9646 4.78387 12.796 5.05161ZM14.3335 7.19766C14.9323 6.31536';
  let path3 =
    '15.5655 5.43834 16.167 4.65822C16.2645 4.74628 16.3736 4.8323 16.4917 4.91425C16.6874 5.05004 16.8921 5.15504 17.1011 5.22694C16.5933 6.0954 16.0473 6.9558 15.3861 7.92958C14.2998 9.53015 13.1704 11.0169 12.2057 12.116C11.6669 12.7299 11.1953 13.2039 10.832 13.4975C10.9722 13.0489 11.2402 12.4332 11.6133 11.7036C12.2803 10.3991 13.2463 8.79887 14.3335 7.19766ZM3.81985 7.19006C3.59711 7.19006 3.37928 7.12705 3.18987 7.00774C2.92218 6.83917 2.73611 6.57652 2.66601 6.26795C2.59592 5.95942 2.65018 5.64205 2.81884 5.37431C3.03695 5.02781 3.41206 4.82091 3.82216 4.82091C4.04495 4.82091 4.26278 4.88392 4.45214 5.00323C5.00475 5.3513 5.17124 6.08405 4.8234 6.63657C4.60506 6.98316 4.22991 7.19006 3.81985 7.19006ZM2.57823 9.79826C2.79643 9.45167 3.17149 9.24477 3.58165 9.24477C3.80434 9.24477 4.02212 9.30782 4.21158 9.42709C4.47927 9.59566 4.66534 9.85835 4.73544 10.1669C4.80558 10.4753 4.75132 10.7926 4.58261 11.0605C4.3645 11.4069 3.98939 11.6139 3.57928 11.6139C3.35654 11.6139 3.13867 11.5509 2.94922 11.4316C2.68152 11.2629 2.4955 11.0003 2.42545 10.6918C2.35545 10.3833 2.40975 10.066 2.57823 9.79826ZM6.37151 2.76357C6.58971 2.41703 6.96482 2.21012 7.37493 2.21012C7.59757 2.21012 7.8154 2.27313 8.00476 2.3924C8.55742 2.74037 8.72391 3.47318 8.37603 4.02579C8.15773 4.37237 7.78262 4.57928 7.37252 4.57928C7.14983 4.57928 6.93199 4.51627 6.74264 4.39696C6.47499 4.22843 6.28896 3.96574 6.21887 3.65716C6.14868 3.34868 6.20294 3.03136 6.37151 2.76357Z';
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="17"
      viewBox="0 0 20 17"
      fill="none"
    >
      <path d={`${path} ${path2} ${path3}`} fill="#F2F2F2" />
    </svg>
  );
};

export const ToolboxIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_14_568)">
        <path
          d="M20 10V7.5C20 6.1193 18.8807 5 17.5 5H2.5C1.1193 5 0 6.1193 0 7.5V10H5V11.6667H0V18.3334C0 18.7936 0.373086 19.1667 0.83332 19.1667H19.1666C19.6269 19.1667 20 18.7936 20 18.3334V11.6667H15V10H20ZM14.1667 13.3333H13.25C13.177 13.6248 13.0648 13.9052 12.9167 14.1666L13.5834 14.8333L12.4167 16L11.75 15.3333L10.9167 15.6666V16.6666H9.16668V15.75L8.33336 15.4167L7.66668 16.0834L6.5 14.8334L7.16668 14.1667C7.01852 13.9052 6.90637 13.6249 6.83336 13.3334H5.83336V11.6667H6.75C6.82305 11.3752 6.93516 11.0948 7.08332 10.8334L6.41664 10.1667L7.58332 9L8.25 9.66668L9.08332 9.33336V8.33336H10.75V9.25L11.5833 9.58332L12.25 8.91664L13.4167 10.0833L12.75 10.75C12.8982 11.0115 13.0103 11.2918 13.0833 11.5833H14.1666V13.3333H14.1667Z"
          fill="#F2F2F2"
        />
        <path
          d="M9.99999 14.1667C10.9205 14.1667 11.6667 13.4205 11.6667 12.5C11.6667 11.5795 10.9205 10.8333 9.99999 10.8333C9.07951 10.8333 8.33331 11.5795 8.33331 12.5C8.33331 13.4205 9.07951 14.1667 9.99999 14.1667Z"
          fill="#F2F2F2"
        />
        <path
          d="M7.50001 2.50001H12.5V4.16669H14.1667V1.66669C14.1667 1.20646 13.7936 0.833374 13.3334 0.833374H6.66669C6.20646 0.833374 5.83337 1.20646 5.83337 1.66669V4.16669H7.50001V2.50001Z"
          fill="#F2F2F2"
        />
      </g>
    </svg>
  );
};

export const HelpdeskIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_13_430)">
        <path
          d="M8.00006 20.1489V23.9999H16.0001V20.3149C15.9805 19.4625 16.1426 18.6157 16.4757 17.8308C16.8089 17.046 17.3053 16.341 17.9321 15.7629C19.2999 14.564 20.2724 12.9786 20.7213 11.2159C21.1702 9.45319 21.0745 7.59582 20.4467 5.88861C19.8189 4.1814 18.6885 2.70449 17.2046 1.65254C15.7206 0.60059 13.9527 0.0229815 12.134 -0.00415542C10.3152 -0.0312924 8.53087 0.493316 7.01621 1.50053C5.50154 2.50773 4.32761 3.95026 3.64916 5.63798C2.97071 7.3257 2.81958 9.17939 3.21568 10.9547C3.61179 12.73 4.53655 14.3437 5.86806 15.5829C6.52026 16.1549 7.04654 16.8561 7.41354 17.6421C7.78054 18.428 7.98027 19.2817 8.00006 20.1489ZM14.0001 21.9999H10.0001V20.1489C10.0001 20.0989 9.99306 20.0489 9.99206 19.9999H14.0161C14.0161 20.1049 14.0001 20.2089 14.0001 20.3149V21.9999ZM5.06006 8.07494C5.20872 6.95312 5.62714 5.88406 6.27947 4.95937C6.93179 4.03468 7.79858 3.28192 8.80556 2.7656C9.81253 2.24928 10.9297 1.98479 12.0613 1.99479C13.1928 2.00479 14.3051 2.28899 15.3028 2.82302C16.3005 3.35706 17.1539 4.12502 17.7897 5.06109C18.4256 5.99717 18.8251 7.07346 18.9539 8.19773C19.0827 9.322 18.937 10.4607 18.5293 11.5164C18.1217 12.572 17.4641 13.5131 16.6131 14.2589C15.5001 15.2555 14.703 16.5559 14.3201 17.9999H13.0001V10.8159C13.583 10.6099 14.088 10.2287 14.446 9.72464C14.804 9.22057 14.9975 8.6182 15.0001 7.99994H13.0001C13.0001 8.26516 12.8947 8.51951 12.7072 8.70705C12.5196 8.89458 12.2653 8.99994 12.0001 8.99994C11.7348 8.99994 11.4805 8.89458 11.293 8.70705C11.1054 8.51951 11.0001 8.26516 11.0001 7.99994H9.00006C9.00262 8.6182 9.19614 9.22057 9.55415 9.72464C9.91215 10.2287 10.4171 10.6099 11.0001 10.8159V17.9999H9.67806C9.22705 16.5092 8.38118 15.1681 7.23006 14.1189C6.4096 13.3598 5.78405 12.4142 5.40633 11.3622C5.02861 10.3101 4.90984 9.18259 5.06006 8.07494Z"
          fill="#F2F2F2"
        />
      </g>
    </svg>
  );
};

export const SettingsIcon = () => {
  let path =
    'M17.745 11.5833L17.375 11.37C17.5416 10.4637 17.5416 9.53463 17.375 8.62833L17.745 8.415C18.0296 8.25085 18.279 8.03226 18.479 7.77172C18.6791 7.51118 18.8259 7.21378 18.911 6.89651C18.9961 6.57925 19.0179 6.24832 18.9751 5.92263C18.9324 5.59694 18.8259 5.28286 18.6617 4.99833C18.4976 4.7138 18.279 4.46439 18.0184 4.26434C17.7579 4.06428 17.4605 3.91751 17.1432 3.83239C16.826 3.74726 16.495 3.72547 16.1693 3.76824C15.8436 3.81101 15.5296 3.91751 15.245 4.08167L14.8742 4.29583C14.1738 3.69743 13.3689 3.23354 12.5 2.9275V2.5C12.5 1.83696 12.2366 1.20107 11.7678 0.732233C11.299 0.263392 10.6631 0 10 0C9.337 0 8.70111 0.263392 8.23227 0.732233C7.76343 1.20107 7.50004 1.83696 7.50004 2.5V2.9275C6.63119 3.23464 5.82658 3.69967 5.1267 4.29917L4.7542';
  let path2 =
    '4.08333C4.17957 3.75181 3.49677 3.66214 2.85602 3.83405C2.21527 4.00596 1.66906 4.42536 1.33754 5C1.00602 5.57464 0.916346 6.25743 1.08825 6.89818C1.26016 7.53893 1.67957 8.08515 2.2542 8.41667L2.6242 8.63C2.45763 9.5363 2.45763 10.4654 2.6242 11.3717L2.2542 11.585C1.67957 11.9165 1.26016 12.4627 1.08825 13.1035C0.916346 13.7442 1.00602 14.427 1.33754 15.0017C1.66906 15.5763 2.21527 15.9957 2.85602 16.1676C3.49677 16.3395 4.17957 16.2499 4.7542 15.9183L5.12504 15.7042C5.82567 16.3027 6.63085 16.7666 7.50004 17.0725V17.5C7.50004 18.163 7.76343 18.7989 8.23227 19.2678C8.70111 19.7366 9.337 20 10 20C10.6631 20 11.299 19.7366 11.7678 19.2678C12.2366 18.7989 12.5 18.163 12.5 17.5V17.0725C13.3689 16.7654 14.1735 16.3003 14.8734 15.7008L15.2459 15.9158C15.8205';
  let path3 =
    '16.2474 16.5033 16.337 17.1441 16.1651C17.7848 15.9932 18.331 15.5738 18.6625 14.9992C18.9941 14.4245 19.0837 13.7417 18.9118 13.101C18.7399 12.4602 18.3205 11.914 17.7459 11.5825L17.745 11.5833ZM15.6217 8.43667C15.9039 9.45922 15.9039 10.5391 15.6217 11.5617C15.5724 11.7396 15.5837 11.9289 15.6537 12.0998C15.7236 12.2707 15.8484 12.4135 16.0084 12.5058L16.9117 13.0275C17.1032 13.138 17.243 13.3201 17.3003 13.5336C17.3575 13.7472 17.3276 13.9747 17.2171 14.1663C17.1066 14.3578 16.9246 14.4975 16.711 14.5548C16.4974 14.6121 16.2699 14.5822 16.0784 14.4717L15.1734 13.9483C15.0133 13.8556 14.8269 13.8188 14.6436 13.8437C14.4603 13.8686 14.2904 13.9538 14.1609 14.0858C13.4191 14.843 12.4847 15.3833 11.4584 15.6483C11.2792 15.6944 11.1205 15.7987 11.0072 15.9449C10.8939';
  let path4 =
    '16.0911 10.8324 16.2709 10.8325 16.4558V17.5C10.8325 17.721 10.7447 17.933 10.5885 18.0893C10.4322 18.2455 10.2202 18.3333 9.9992 18.3333C9.77819 18.3333 9.56623 18.2455 9.40995 18.0893C9.25367 17.933 9.16587 17.721 9.16587 17.5V16.4567C9.16596 16.2717 9.10451 16.092 8.99121 15.9458C8.8779 15.7996 8.71918 15.6952 8.54004 15.6492C7.51366 15.3831 6.57948 14.8416 5.83837 14.0833C5.70881 13.9513 5.53898 13.8661 5.35567 13.8412C5.17235 13.8163 4.98596 13.8531 4.82587 13.9458L3.92254 14.4683C3.82773 14.5239 3.72286 14.5602 3.61397 14.5751C3.50509 14.59 3.39433 14.5832 3.28808 14.5551C3.18183 14.527 3.08219 14.4782 2.99489 14.4114C2.90759 14.3446 2.83435 14.2613 2.7794 14.1661C2.72445 14.0709 2.68887 13.9658 2.6747 13.8568C2.66053 13.7479 2.66807 13.6372 2.69686 13.5311C2.72566 13.425 2.77515 13.3257 2.84248 13.2389C2.90981 13.152 2.99366 13.0793 3.0892 13.025L3.99254 12.5033C4.15249 12.411 4.27726 12.2682 4.34725 12.0973C4.41724 11.9264 4.42848 11.7371 4.3792 11.5592C4.097 10.5366 4.097 9.45672 4.3792 8.43417C4.42759 8.25657 4.41582 8.06795 4.34571 7.89774C4.27561 7.72754 4.15113 7.58534 3.9917 7.49333L3.08837 6.97167C2.89686 6.86116 2.75709 6.6791 2.69982 6.46555C2.64254 6.25199 2.67245 6.02442 2.78295 5.83292C2.89346 5.64141 3.07552 5.50164 3.28907 5.44437C3.50263 5.38709 3.73019 5.41699 3.9217 5.5275L4.8267 6.05083C4.98635 6.14376 5.17235 6.18101 5.35548 6.15672C5.5386 6.13244 5.70846 6.048 5.83837 5.91667C6.58011 5.15945 7.51456 4.61918 8.54087 4.35417C8.72056 4.30797 8.8797 4.20313 8.99306 4.05625C9.10643 3.90938 9.16754 3.72887 9.1667 3.54333V2.5C9.1667 2.27899 9.2545 2.06702 9.41078 1.91074C9.56706 1.75446 9.77902 1.66667 10 1.66667C10.2211 1.66667 10.433 1.75446 10.5893 1.91074C10.7456 2.06702 10.8334 2.27899 10.8334';
  let path5 =
    '2.5V3.54333C10.8333 3.7283 10.8947 3.90804 11.008 4.05423C11.1213 4.20043 11.2801 4.30478 11.4592 4.35083C12.4859 4.61679 13.4204 5.15824 14.1617 5.91667C14.2913 6.04872 14.4611 6.13391 14.6444 6.15881C14.8277 6.1837 15.0141 6.14689 15.1742 6.05417L16.0775 5.53167C16.1723 5.47609 16.2772 5.43981 16.3861 5.42492C16.495 5.41003 16.6057 5.41683 16.712 5.44492C16.8182 5.47301 16.9179 5.52184 17.0052 5.58859C17.0925 5.65535 17.1657 5.73872 17.2207 5.83389C17.2756 5.92907 17.3112 6.03417 17.3254 6.14316C17.3395 6.25214 17.332 6.36285 17.3032 6.46891C17.2744 6.57497 17.2249 6.67429 17.1576 6.76114C17.0903 6.848 17.0064 6.92068 16.9109 6.975L16.0075 7.49667C15.8484 7.58892 15.7243 7.73123 15.6545 7.90141C15.5847 8.07159 15.5732 8.26008 15.6217 8.4375V8.43667Z';
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_14_441)">
        <path
          d="M10.0001 6.66718C9.34081 6.66718 8.69635 6.86267 8.14818 7.22894C7.60002 7.59521 7.17278 8.11581 6.92048 8.7249C6.66819 9.33398 6.60218 10.0042 6.7308 10.6508C6.85942 11.2974 7.17689 11.8914 7.64306 12.3575C8.10924 12.8237 8.70318 13.1412 9.34978 13.2698C9.99639 13.3984 10.6666 13.3324 11.2757 13.0801C11.8848 12.8278 12.4054 12.4006 12.7716 11.8524C13.1379 11.3042 13.3334 10.6598 13.3334 10.0005C13.3334 9.11645 12.9822 8.26861 12.3571 7.64349C11.732 7.01836 10.8841 6.66718 10.0001 6.66718ZM10.0001 11.6672C9.67045 11.6672 9.34822 11.5694 9.07413 11.3863C8.80005 11.2032 8.58643 10.9429 8.46028 10.6383C8.33414 10.3338 8.30113 9.99866 8.36544 9.67536C8.42975 9.35206 8.58848 9.05509 8.82157 8.822C9.05466 8.58891 9.35163 8.43017 9.67493 8.36587C9.99823 8.30156 10.3333 8.33456 10.6379 8.46071C10.9424 8.58686 11.2027 8.80048 11.3859 9.07456C11.569 9.34864 11.6668 9.67087 11.6668 10.0005C11.6668 10.4425 11.4912 10.8665 11.1786 11.179C10.866 11.4916 10.4421 11.6672 10.0001 11.6672Z"
          fill="#F2F2F2"
        />
        <path
          d={`${path} ${path2} ${path3} ${path4} ${path5}`}
          fill="#F2F2F2"
        />
      </g>
    </svg>
  );
};

export const MangeIcon = () => {
  return (
    <svg
      className="Polaris-Icon__Svg"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M8.89199 10.8499C8.70866 10.8416 8.52532 10.8333 8.33366 10.8333C6.31699 10.8333 4.43366 11.3916 2.82533 12.3499C2.09199 12.7833 1.66699 13.5999 1.66699 14.4583V15.8333C1.66699 16.2916 2.04199 16.6666 2.50033 16.6666H9.38366C8.79507 15.8269 8.43948 14.8463 8.35312 13.8246C8.26675 12.8028 8.45269 11.7764 8.89199 10.8499Z"
        fill="#5C5F62"
      />
      <path
        d="M8.33333 9.99992C10.1743 9.99992 11.6667 8.50753 11.6667 6.66659C11.6667 4.82564 10.1743 3.33325 8.33333 3.33325C6.49238 3.33325 5 4.82564 5 6.66659C5 8.50753 6.49238 9.99992 8.33333 9.99992Z"
        fill="#5C5F62"
      />
      <path
        d="M17.2914 13.3334C17.2914 13.15 17.2664 12.9834 17.2414 12.8084L17.9414 12.2C18.0914 12.0667 18.1247 11.85 18.0247 11.675L17.5331 10.825C17.486 10.7414 17.4108 10.677 17.3208 10.6435C17.2308 10.6099 17.1318 10.6093 17.0414 10.6417L16.1581 10.9417C15.8914 10.7167 15.5914 10.5417 15.2581 10.4167L15.0747 9.50838C15.0551 9.41448 15.0038 9.33016 14.9295 9.2695C14.8552 9.20883 14.7623 9.1755 14.6664 9.17505H13.6831C13.4831 9.17505 13.3164 9.31672 13.2747 9.50838L13.0914 10.4167C12.7581 10.5417 12.4581 10.7167 12.1914 10.9417L11.3081 10.6417C11.2176 10.6106 11.1191 10.6119 11.0294 10.6454C10.9398 10.6788 10.8645 10.7423 10.8164 10.825L10.3247 11.675C10.2247 11.85 10.2581 12.0667 10.4081 12.2L11.1081 12.8084C11.0831 12.9834 11.0581 13.15 11.0581 13.3334C11.0581 13.5167 11.0831 13.6834 11.1081 13.8584L10.4081 14.4667C10.2581 14.6 10.2247 14.8167 10.3247 14.9917L10.8164 15.8417C10.9164 16.0167 11.1247 16.0917 11.3081 16.025L12.1914 15.725C12.4581 15.95 12.7581 16.125 13.0914 16.25L13.2747 17.1584C13.3164 17.35 13.4831 17.4917 13.6831 17.4917H14.6664C14.8664 17.4917 15.0331 17.35 15.0747 17.1584L15.2581 16.25C15.5914 16.125 15.8914 15.95 16.1581 15.725L17.0414 16.025C17.2331 16.0917 17.4331 16.0084 17.5331 15.8417L18.0247 14.9917C18.1247 14.8167 18.0914 14.6 17.9414 14.4667L17.2414 13.8584C17.2664 13.6834 17.2914 13.5167 17.2914 13.3334ZM14.1664 15C13.2497 15 12.4997 14.25 12.4997 13.3334C12.4997 12.4167 13.2497 11.6667 14.1664 11.6667C15.0831 11.6667 15.8331 12.4167 15.8331 13.3334C15.8331 14.25 15.0831 15 14.1664 15Z"
        fill="#5C5F62"
      />
    </svg>
  );
};

export const SubscriptionIcon = () => {
  return (
    <svg
      className="Polaris-Icon__Svg"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M15.667 5.66675H2.33366V4.00008H15.667V5.66675ZM14.0003 0.666748H4.00033V2.33341H14.0003V0.666748ZM17.3337 9.00008V15.6667C17.3337 16.1088 17.1581 16.5327 16.8455 16.8453C16.5329 17.1578 16.109 17.3334 15.667 17.3334H2.33366C1.89204 17.3321 1.46888 17.1561 1.1566 16.8438C0.844329 16.5315 0.668311 16.1084 0.666992 15.6667V9.00008C0.668311 8.55846 0.844329 8.1353 1.1566 7.82303C1.46888 7.51075 1.89204 7.33473 2.33366 7.33342H15.667C16.1086 7.33473 16.5318 7.51075 16.844 7.82303C17.1563 8.1353 17.3323 8.55846 17.3337 9.00008ZM10.6062 13.2017L12.542 11.5467L9.99283 11.3334L9.00033 9.00008L8.00783 11.3334L5.45866 11.5467L7.39449 13.2017L6.81116 15.6667L9.00033 14.3567L11.1895 15.6667L10.6062 13.2017Z"
        fill="#5C5F62"
      />
    </svg>
  );
};

export const CrystalBall = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" id="Icons" viewBox="0 0 48 48">
      <defs>
        <style>
          {`
              .cls-1{fill:#45413c;opacity:0.15;}
              .cls-2{fill:#915e3a;}
              .cls-2,.cls-5,.cls-9{stroke:#45413c;strokeLinecap:round;strokeLinejoin:round;}
              .cls-3{fill:#dea47a;}
              .cls-4{fill:#bf8256;}
              .cls-5{fill:none;}
              .cls-6{fill:#bf8df2;}
              .cls-7{fill:#9f5ae5;}
              .cls-8{fill:#dabff5;}
              .cls-9{fill:#fff;}
            `}
        </style>
      </defs>
      <title>743-crystal-ball-1</title>
      <g id="_Group_" data-name="&lt;Group&gt;">
        <ellipse
          id="_Ellipse_"
          data-name="&lt;Ellipse&gt;"
          className="cls-1"
          cx="24"
          cy="44.5"
          rx="14"
          ry="1.5"
        />
        <g id="_Group_2" data-name="&lt;Group&gt;">
          <g id="_Group_3" data-name="&lt;Group&gt;">
            <path
              id="_Path_"
              data-name="&lt;Path&gt;"
              className="cls-2"
              d="M34,35.65a24.73,24.73,0,0,1-10,2.21,24.73,24.73,0,0,1-10-2.21,67.53,67.53,0,0,1,19.94,0Z"
            />
            <path
              id="_Path_2"
              data-name="&lt;Path&gt;"
              className="cls-3"
              d="M36.37,40.43a1.48,1.48,0,0,1-.55,1.92c-1.76,1.09-5.61,2.9-11.82,2.9s-10.06-1.81-11.82-2.9a1.48,1.48,0,0,1-.55-1.92L14,35.65a24.73,24.73,0,0,0,10,2.21,24.73,24.73,0,0,0,10-2.21Z"
            />
            <path
              id="_Path_3"
              data-name="&lt;Path&gt;"
              className="cls-4"
              d="M24,40.56a34.6,34.6,0,0,0,11.4-2.07L34,35.65a24.73,24.73,0,0,1-10,2.21,24.73,24.73,0,0,1-10-2.21L12.6,38.49A34.6,34.6,0,0,0,24,40.56Z"
            />
            <path
              id="_Path_4"
              data-name="&lt;Path&gt;"
              className="cls-5"
              d="M36.37,40.43a1.48,1.48,0,0,1-.55,1.92c-1.76,1.09-5.61,2.9-11.82,2.9s-10.06-1.81-11.82-2.9a1.48,1.48,0,0,1-.55-1.92L14,35.65a24.73,24.73,0,0,0,10,2.21,24.73,24.73,0,0,0,10-2.21Z"
            />
          </g>
          <g id="_Group_4" data-name="&lt;Group&gt;">
            <g id="_Group_5" data-name="&lt;Group&gt;">
              <circle
                id="_Ellipse_2"
                data-name="&lt;Ellipse&gt;"
                className="cls-6"
                cx="24"
                cy="20.5"
                r="15.15"
              />
              <path
                id="_Compound_Path_"
                data-name="&lt;Compound Path&gt;"
                className="cls-7"
                d="M24,5.35A15.15,15.15,0,1,0,39.15,20.5,15.15,15.15,0,0,0,24,5.35ZM24,30.1A12.19,12.19,0,1,1,36.19,17.91,12.19,12.19,0,0,1,24,30.1Z"
              />
              <circle
                id="_Ellipse_3"
                data-name="&lt;Ellipse&gt;"
                className="cls-5"
                cx="24"
                cy="20.5"
                r="15.15"
              />
            </g>
            <circle
              id="_Ellipse_4"
              data-name="&lt;Ellipse&gt;"
              className="cls-8"
              cx="29.91"
              cy="15.33"
              r="3.69"
            />
            <circle
              id="_Ellipse_5"
              data-name="&lt;Ellipse&gt;"
              className="cls-8"
              cx="22.89"
              cy="17.17"
              r="1.11"
            />
            <circle
              id="_Ellipse_6"
              data-name="&lt;Ellipse&gt;"
              className="cls-8"
              cx="23.63"
              cy="11.26"
              r="1.85"
            />
          </g>
          <path
            id="_Path_5"
            data-name="&lt;Path&gt;"
            className="cls-5"
            d="M40.62,28.26a6.4,6.4,0,0,1-2.95,4.43"
          />
          <path
            id="_Path_6"
            data-name="&lt;Path&gt;"
            className="cls-5"
            d="M36.93,34.91a5.64,5.64,0,0,0,3.69-2.22"
          />
          <path
            id="_Path_7"
            data-name="&lt;Path&gt;"
            className="cls-5"
            d="M5.9,15.7s.74-3.7,2.95-5.18"
          />
          <path
            id="_Path_8"
            data-name="&lt;Path&gt;"
            className="cls-5"
            d="M4.42,12.74a11,11,0,0,0,0,5.17"
          />
          <path
            id="_Path_9"
            data-name="&lt;Path&gt;"
            className="cls-9"
            d="M42,8.42a1.79,1.79,0,0,1,1.33-1.33L46,6.48a.22.22,0,0,0,.18-.22A.21.21,0,0,0,46,6.05l-2.66-.62A1.77,1.77,0,0,1,42,4.1l-.62-2.66a.22.22,0,0,0-.21-.18.23.23,0,0,0-.22.18L40.34,4.1A1.79,1.79,0,0,1,39,5.43l-2.67.62a.21.21,0,0,0-.17.21.22.22,0,0,0,.17.22L39,7.09a1.77,1.77,0,0,1,1.32,1.33L41,11.09a.22.22,0,0,0,.22.17.21.21,0,0,0,.21-.17Z"
          />
          <path
            id="_Path_10"
            data-name="&lt;Path&gt;"
            className="cls-9"
            d="M5.82,32.31l2.09-.69A.2.2,0,0,0,8,31.43a.18.18,0,0,0-.13-.18l-1.72-.57a.79.79,0,0,1-.49-.5l-.58-1.72a.18.18,0,0,0-.18-.13.2.2,0,0,0-.19.13l-.57,1.72a.8.8,0,0,1-.5.5L2,31.25a.19.19,0,0,0-.14.18.2.2,0,0,0,.14.19l1.71.57a.78.78,0,0,1,.5.5l.57,1.71a.2.2,0,0,0,.19.14.19.19,0,0,0,.18-.14Z"
          />
        </g>
      </g>
    </svg>
  );
};

export const BarChartIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M11 3.001C10.6022 3.001 10.2206 3.15903 9.93934 3.44034C9.65804 3.72164 9.5 4.10317 9.5 4.501V19.501C9.5 19.8988 9.65804 20.2804 9.93934 20.5617C10.2206 20.843 10.6022 21.001 11 21.001H13C13.3978 21.001 13.7794 20.843 14.0607 20.5617C14.342 20.2804 14.5 19.8988 14.5 19.501V4.501C14.5 4.10317 14.342 3.72164 14.0607 3.44034C13.7794 3.15903 13.3978 3.001 13 3.001H11ZM4.5 13.001C4.10218 13.001 3.72064 13.159 3.43934 13.4403C3.15804 13.7216 3 14.1032 3 14.501V19.501C3 19.8988 3.15804 20.2804 3.43934 20.5617C3.72064 20.843 4.10218 21.001 4.5 21.001H6.5C6.89782 21.001 7.27936 20.843 7.56066 20.5617C7.84196 20.2804 8 19.8988 8 19.501V14.501C8 14.1032 7.84196 13.7216 7.56066 13.4403C7.27936 13.159 6.89782 13.001 6.5 13.001H4.5ZM16 9.501C16 9.10318 16.158 8.72164 16.4393 8.44034C16.7206 8.15904 17.1022 8.001 17.5 8.001H19.5C19.8978 8.001 20.2794 8.15904 20.5607 8.44034C20.842 8.72164 21 9.10318 21 9.501V19.501C21 19.8988 20.842 20.2804 20.5607 20.5617C20.2794 20.843 19.8978 21.001 19.5 21.001H17.5C17.1022 21.001 16.7206 20.843 16.4393 20.5617C16.158 20.2804 16 19.8988 16 19.501V9.501Z"
        fill="#111111"
      />
    </svg>
  );
};
export const ToggleButtonIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
    >
      <g clipPath="url(#clip0_2_133)">
        <mask
          id="mask0_2_133"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="25"
          height="25"
        >
          <path
            d="M0.72998 0.160004H24.97V24.4H0.72998V0.160004Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_2_133)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.24487 12.0275C2.24487 10.4873 2.85673 9.0101 3.94585 7.92098C5.03497 6.83186 6.51213 6.22 8.05237 6.22H18.6574C20.1976 6.22 21.6748 6.83186 22.7639 7.92098C23.853 9.0101 24.4649 10.4873 24.4649 12.0275V12.5325C24.4649 14.0727 23.853 15.5499 22.7639 16.639C21.6748 17.7281 20.1976 18.34 18.6574 18.34H8.05237C6.51213 18.34 5.03497 17.7281 3.94585 16.639C2.85673 15.5499 2.24487 14.0727 2.24487 12.5325V12.0275ZM18.4049 7.735C17.1995 7.735 16.0434 8.21385 15.1911 9.0662C14.3387 9.91855 13.8599 11.0746 13.8599 12.28C13.8599 13.4854 14.3387 14.6414 15.1911 15.4938C16.0434 16.3462 17.1995 16.825 18.4049 16.825C19.6103 16.825 20.7663 16.3462 21.6187 15.4938C22.471 14.6414 22.9499 13.4854 22.9499 12.28C22.9499 11.0746 22.471 9.91855 21.6187 9.0662C20.7663 8.21385 19.6103 7.735 18.4049 7.735Z"
            fill="#111111"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_2_133">
          <rect
            width="24.24"
            height="24.24"
            fill="white"
            transform="translate(0.72998 0.160004)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const PlayIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <g clipPath="url(#clip0_3_286)">
        <mask
          id="mask0_3_286"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="25"
        >
          <path d="M0 0.669983H24V24.67H0V0.669983Z" fill="white" />
        </mask>
        <g mask="url(#mask0_3_286)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13 1.52699C13.0024 1.3678 12.9607 1.21106 12.8795 1.0741C12.7983 0.937147 12.6808 0.825319 12.54 0.75099C12.4028 0.682017 12.2478 0.656368 12.0957 0.67744C11.9435 0.698513 11.8013 0.765312 11.688 0.86899L9.28801 3.01199C9.19658 3.09537 9.12369 3.19703 9.07408 3.31038C9.02447 3.42374 8.99923 3.54626 9.00001 3.66999C9.00001 3.92399 9.10501 4.16599 9.28801 4.32799L11.688 6.47099C11.926 6.68399 12.258 6.73099 12.539 6.58899C12.68 6.5148 12.7977 6.40303 12.879 6.26606C12.9604 6.1291 13.0023 5.97228 13 5.81299V4.73199C15.0173 4.98867 16.8612 6.00386 18.1568 7.57121C19.4525 9.13856 20.1027 11.1405 19.9754 13.17C19.848 15.1996 18.9527 17.1045 17.4713 18.4976C15.9898 19.8907 14.0336 20.6675 12 20.67C10.4897 20.6701 9.01024 20.2427 7.73269 19.4371C6.45513 18.6316 5.4317 17.4809 4.78073 16.1181C4.12977 14.7553 3.87788 13.2361 4.05418 11.7361C4.23049 10.2361 4.82779 8.81671 5.77701 7.64199C5.93601 7.43517 6.00789 7.17441 5.97733 6.91534C5.94677 6.65627 5.81617 6.41939 5.61341 6.25525C5.41065 6.09111 5.15178 6.01271 4.89202 6.03676C4.63226 6.06081 4.39218 6.18541 4.22301 6.38399C2.78199 8.16179 1.997 10.3815 2.00001 12.67C2.00001 18.193 6.47701 22.67 12 22.67C17.523 22.67 22 18.193 22 12.67C22 7.48499 18.053 3.22099 13 2.71999V1.52699ZM9.00001 9.37299C9.00001 8.82599 9.61101 8.48899 10.09 8.77299L15.654 12.07C15.7593 12.1308 15.8467 12.2183 15.9075 12.3236C15.9682 12.4289 16.0002 12.5484 16.0002 12.67C16.0002 12.7916 15.9682 12.911 15.9075 13.0164C15.8467 13.1217 15.7593 13.2091 15.654 13.27L10.089 16.567C9.61101 16.851 9.00001 16.514 9.00001 15.967V9.37299Z"
            fill="#111111"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_3_286">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.669983)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
